import { lazy } from 'react';
import type React from 'react';

const lazyWithErrorHandling = (
  importFunc: () => Promise<{ default: React.ComponentType<unknown> }>,
) => {
  return lazy(() =>
    importFunc().catch(() => {
      window.location.reload();
      return Promise.resolve({ default: () => null });
    }),
  );
};

export default lazyWithErrorHandling;
